import { HttpClient } from "@angular/common/http";
import { IResponseService } from "../interfaces/response-service";
import { SectionsService } from "../services/sections.service";
import { MenuModel } from "../shared/models/menu-model";
import { CuentaMatriculaModel } from "../shared/models/cuenta-matricula-model";
import { UserModel } from "../shared/models/user-model";
import { AsociadoModel } from "../shared/models/datosAsociado";

export class MainStore {

  public static ORIGIN: number = 1;
  private static instance: MainStore;

  /**
   * @author Jose Wilson Mulato
   * @description metodo por el cual obtiene el unico lugar de almacenamiento de los formulario del cliente
   */
  public static get db() {
    return this.instance || (this.instance = new MainStore());
  }

  private data: any;
  private sectionsService: SectionsService = undefined;

  constructor() {
    this.RestData();
  }

  /**
   * @author Jose Wilson Mulato
   * @description Se asigna la instacia de http, para solitar su servicio
   * @param http HttpClient
   */
  public SetHttpClient(http: HttpClient) {
    this.sectionsService = new SectionsService(http);
  }

  /**
   * @author Jose Wilson Mulato
   * @description Limpia todos los valores
   */
  public RestData() {
    this.data = {};
  }


  /**
   * @author Jose Wilson Mulato
   * @description Obtener el usuario que esta logueado
   */
  public GetUser() {
    if(this.data != undefined && this.data != null && this.data.user != undefined
      && this.data.user != null) {
      return this.data.user;
    } else {
      return {nombre1: false};
    }
    
  }  


  /**
   * @author Jose Wilson Mulato
   * @description Establese el usuario que va usar la aplicación
   * @param user UserModel
   */
  public SetUser(user: AsociadoModel) {
    this.data.user = user;
  }


  /**
   * @author Jose Wilson Mulato
   * @description Oteniendo el menú agregado
   */
  public GetMenu(): MenuModel[] {
    return this.data.menu;
  }

  /**
   * @author Jose Wilson Mulato
   * @description Agregando al menú items
   * @param item
   */
  public AddMenu(...items: MenuModel[]) {
    items.forEach(x => this.data.menu.push(x));
  }

  /**
   * @author Jose Wilson Mulato
   * @description Agregando al menú items
   */
  public ClearMenu() {
    this.data.menu = [];
  }

  /**
   * @author Jose Wilson Mulato
   * @description Guarda la donacion por pinos
   * @param data
   */
  async MatricularCuenta(data: CuentaMatriculaModel) {
    return new Promise((success, fail) => {
      this.SaveSection("matricularCuenta", data)
        .then((response: IResponseService) => {
          success(response);
        })
        .catch(error => {
          fail(error);
        });
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description Envia dinamicamente a los servicios correspondientes y adiciona en los atributtos IP, Usuario Creacion,  Usuario Modificación
   * @param funt el servicio que se va a llamar para guardar
   * @param data el dato que se va enviar a guardar
   */
  private async SaveSection(funt: string, data: any) {
    return new Promise((success, fail) => {
      this.sectionsService[funt](data)
        .then(response => {
          success(response);
        })
        .catch(error => {
          fail(error);
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store/main-store.ts